import events from '@/constants/events'
import EventBus from '@/EventBus'
import { ROUTE_NAMES } from '@/constants/routes'
import localStorage from '@/utils/localStorage'

const HISTORY_LENGTH = 10

const ROUTES_TO_TRACK = [
  ROUTE_NAMES.GOAL,
  ROUTE_NAMES.KR,
  ROUTE_NAMES.INITIATIVE,
  ROUTE_NAMES.IDEA_LIST,
  ROUTE_NAMES.IDEA
]

export const addToHistory = route => {
  const { name, params, query, fullPath, path, values } = route
  const { orgId } = params
  if (orgId && ROUTES_TO_TRACK.includes(name)) {
    let recentPages = localStorage.getItem('recentPages')
    recentPages = recentPages ? JSON.parse(recentPages) : {}
    let orgRecentPages = recentPages[orgId] || []
    orgRecentPages = orgRecentPages.filter(page => page.path !== path)
    orgRecentPages.unshift({ name, params, query, fullPath, path, values })
    if (orgRecentPages.length > HISTORY_LENGTH) {
      orgRecentPages = orgRecentPages.slice(0, HISTORY_LENGTH)
    }
    recentPages[orgId] = orgRecentPages
    localStorage.setItem('recentPages', JSON.stringify(recentPages))
    EventBus.$emit(events.VISIT_HISTORY_UPDATED)
  }
}

export const clearPageVisitHistory = () => {
  localStorage.removeItem('recentPages')
}

/**
 * This will fill title/value corresponding to certain id
 * the valuesEntries should be array of tuple. A tuple may look like  [1, 'teamId', 14, 'Marketing', ]
 * This will update all entries for orgId: 1,  which has teamId=14 as path param or query param
 */
EventBus.$on('UPDATE_RECENT_PAGES_DATA', valueEntries => {
  let recentPages = localStorage.getItem('recentPages')
  recentPages = recentPages ? JSON.parse(recentPages) : []
  valueEntries.forEach(([orgId, key, id, value]) => {
    let orgRecentPages = recentPages[orgId] || []
    orgRecentPages = orgRecentPages.map(page => {
      page.values = page.values || []
      if (String(page.params[key]) === String(id)) {
        // remove items corresponding to current key
        page.values = page.values.filter(([existingKey]) => existingKey !== key)
        page.values.push([key, id, value])
      }
      if (String(page.query[key]) === String(id)) {
        page.values = page.values.filter(([existingKey]) => existingKey !== key)
        page.values.push([key, id, value])
      }
      return page
    })
    recentPages[orgId] = orgRecentPages
  })
  localStorage.setItem('recentPages', JSON.stringify(recentPages))
})
